module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('v-navigation-drawer', {
    staticClass: "pb-0 app-sidebar",
    attrs: {
      "floating": "",
      "absolute": "",
      "height": "calc(100vh - 64px)",
      "clipped": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.controls.sidebarOpen),
      callback: function($$v) {
        _vm.$set(_vm.controls, "sidebarOpen", $$v)
      },
      expression: "controls.sidebarOpen"
    }
  }, [_vm._l((_vm.arrNav), function(item, index) {
    return (item.auth === !!_vm.user) ? _c('router-link', {
      key: index,
      staticClass: "app-sidebar__link list__tile--active",
      attrs: {
        "to": item.path
      }
    }, [_c('i', {
      staticClass: "material-icons app-sidebar__icon"
    }, [_vm._v(_vm._s(item.icon))]), _vm._v("\n      " + _vm._s(item.title) + "\n    ")]) : _vm._e()
  }), _vm._v(" "), (_vm.user) ? _c('a', {
    staticClass: "app-sidebar__link list__tile--active",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons app-sidebar__icon"
  }, [_vm._v("lock")]), _vm._v("\n      Sign Out\n    ")]) : _c('router-link', {
    staticClass: "app-sidebar__link list__tile--active",
    attrs: {
      "to": "/signIn"
    }
  }, [_c('i', {
    staticClass: "material-icons app-sidebar__icon"
  }, [_vm._v("lock")]), _vm._v("\n      Admin\n    ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "app-nav"
  }, [_c('div', {
    staticClass: "app-nav__primary-section"
  }, [_c('v-toolbar-title', {
    staticClass: "app-sidebar-toggle"
  }, [_c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.controls.sidebarOpen = !_vm.controls.sidebarOpen
      }
    }
  })], 1), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false)], 1), _vm._v(" "), _c('div', {
    staticClass: "app-nav__secondary-section"
  }, [_vm._l((_vm.arrNav), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "app-nav__link",
      attrs: {
        "to": item.path
      }
    }, [(item.auth === !!_vm.user) ? _c('v-btn', {
      staticClass: "app-nav__button",
      attrs: {
        "flat": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.user) ? _c('a', {
    staticClass: "app-nav__link"
  }, [_c('v-btn', {
    staticClass: "app-nav__button--small",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock")]), _vm._v("\n          Sign Out\n        ")])], 1) : _c('router-link', {
    staticClass: "app-nav__link",
    attrs: {
      "to": "/signIn"
    }
  }, [_c('v-btn', {
    staticClass: "app-nav__button--small",
    attrs: {
      "flat": ""
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock")]), _vm._v("\n          Admin\n        ")])], 1)], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "app-nav__crk",
    attrs: {
      "href": "http://www.chattahoochee.org",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "app-nav__crk-logo",
    attrs: {
      "src": require("../assets/crk-logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "app-nav__nww",
    attrs: {
      "href": "https://chattahoochee.org/our-work/water-monitoring/neighborhood-water-watch/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "app-nav__nww-logo"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10ce147c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-nav.vue
// module id = 437
// module chunks = 1